import {RestResource} from '../rest'

import {ORGANIZATION_SERVER} from '../server'
import {athubAxios} from "@/util";

const employee = new RestResource({server: ORGANIZATION_SERVER, resource: 'employee'});

employee.checkJobCode = (jobCode, athubConfig) => {
    return new Promise((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/employee/jobCodeCheck/${jobCode}`).then(res => {
            if (res.status == 200) {
                resolve(res);
            }
        }).catch(error => {
            reject(error);
        });
    });
};

export default employee;